import request from '@/utils/request'

//反馈
export function coupleBackSave(data) {
	return request({
		url: '/api/coupleBack/coupleBackSave',
		method: 'post',
		data
	})
}
//我的反馈
export function getMyCoupleBack(data) {
	return request({
		url: '/api/coupleBack/getMyCoupleBack',
		method: 'get',
		params:data
	})
}

